import { createStyles } from "@material-ui/core";

export const styles = createStyles({
  listItem: {
    height: 40,
    marginTop: 7,
    transition: "none",
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeListItem: {
    width: 255,
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
});
